<template>
    <div style="height: 100%">
        <v-card height="100%">
            <GmapMap
                ref="map"
                v-if="meter"
                :center="{
                    lat: meter.location.latitude,
                    lng: meter.location.longitude,
                }"
                :zoom="17"
                :options="{
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                }"
                map-type-id="roadmap"
                class="map"
            >
                <GmapMarker
                    id="meter.name"
                    v-if="meter.location"
                    :position="{
                        lat: meter.location.latitude,
                        lng: meter.location.longitude,
                    }"
                />
            </GmapMap>
            <div class="redirect">
                <v-btn-toggle>
                    <v-btn small color="white" class="accent--text" @click="displayMap()">Show on Map</v-btn>              
                </v-btn-toggle>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'mapMeter',
    props: ['meter'],
    methods: {
        displayMap(){
            this.$router.push({ name: 'Map', params: { location: this.meter.location, id: 'general', zoom: 16, btn: 4, signal: false } })
        }
    }
}
</script>

<style scoped>
.map{
    height: 340px;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
}
.redirect{
    position: absolute;
    top: 10px;
    left: 10px
}
</style>